<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <HelloWorld msg="mohe"/>
    <!-- <Mobile v-if="!isPc" msg="everyLink"/> -->
  </div>
</template>

<script>
import HelloWorld from './components/Home.vue'
// import Mobile from './components/mobile.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    // Mobile
  },
  data () {
    return {
      isPc:false,
    }
  },
  mounted(){
    if ((navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))) {
        // document.write("手机访问.");
        this.isPc = false
    }else{
        // document.write("电脑访问.");
        this.isPc = true
    }
  },
  methods:{

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>
